import ClowncarAppConstants from 'constants/ClowncarAppConstants';

const initialState = {
  isInitialized: false,
  phoneNumberAllocationList: [],
  requestInProgress: false,
  phoneNumberSelected: null,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.PHONE_NUMBER_INSERT_STARTING:
    case ClowncarAppConstants.PHONE_NUMBER_UPDATE_STARTING:
    case ClowncarAppConstants.PHONE_NUMBER_GET_ALL_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case ClowncarAppConstants.PHONE_NUMBER_GET_ALL_DONE: {
      return {
        ...state,
        requestInProgress: false,
        phoneNumberAllocationList: payload,
        isInitialized: true,
      };
    }
    case ClowncarAppConstants.PHONE_NUMBER_SELECT: {
      return {
        ...state,
        phoneNumberSelected: payload,
      };
    }
    case ClowncarAppConstants.PHONE_NUMBER_UPDATE_DONE: {
      return {
        ...state,
        phoneNumberSelected: payload,
        requestInProgress: false,
      };
    }
    case ClowncarAppConstants.PHONE_NUMBER_INSERT_DONE:
    case ClowncarAppConstants.PHONE_NUMBER_INSERT_FAILED:
    case ClowncarAppConstants.PHONE_NUMBER_UPDATE_FAILED:
    case ClowncarAppConstants.PHONE_NUMBER_GET_ALL_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    default:
      return state;
  }
}
